import axios, { AxiosResponse } from "axios";

export default new (class ApiService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = process.env.REACT_APP_API_BASE_URL || "";
    if (!this.baseUrl) {
      console.error("Base URL is not defined in the environment variables.");
    }
  }

  async fetchHomeDatas<T>(endpoint: string): Promise<T> {
    try {
      const fullUrl = `${this.baseUrl}${endpoint}`;
      const response = await axios.get<T>(fullUrl);

      if (!response.data) {
        throw new Error(`No data returned from ${fullUrl}`);
      }

      return response && response.data;
    } catch (error) {
      console.error("Error fetching data from:", endpoint, error);
      throw error;
    }
  }
})();
